'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _countryData = require('country-data');

var _semanticUiReact = require('semantic-ui-react');

var _reactEllipsisText = require('react-ellipsis-text');

var _reactEllipsisText2 = _interopRequireDefault(_reactEllipsisText);

var _formatting = require('../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCountry = function getCountry(code) {
  return _lodash2.default.find(_countryData.countries.all, ['alpha2', _lodash2.default.upperCase(code)]);
};
var DemographicsRow = function DemographicsRow(_ref) {
  var row = _ref.row,
      uniqueKey = _ref.uniqueKey,
      metric = _ref.metric,
      totalMetric = _ref.totalMetric;

  var countryKey = uniqueKey === 'location' && _lodash2.default.has(row, 'location') ? 'location' : 'countryCode';
  var country = getCountry(row[countryKey]);
  var percentage = row.percentage || 100 * row[metric] / totalMetric;
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    null,
    country ? _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'left' },
      country.emoji,
      ' ',
      _react2.default.createElement(_reactEllipsisText2.default, { text: country.name, length: 16 })
    ) : _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'left' },
      _react2.default.createElement(_reactEllipsisText2.default, { text: row[uniqueKey] || '', length: 16 })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.commaFormatted)(row[metric])
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.commaFormatted)(percentage),
      ' %'
    )
  );
};

DemographicsRow.propTypes = {
  row: _propTypes2.default.object.isRequired,
  uniqueKey: _propTypes2.default.string.isRequired,
  metric: _propTypes2.default.string.isRequired,
  totalMetric: _propTypes2.default.number.isRequired
};

exports.default = DemographicsRow;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/demographics-location-table/demographic-row.js
 ** module id = 2579
 ** module chunks = 0
 **/